export type ComponentBreakpoint = 'desktop' | 'tablet';
export type TableHeadContentType = 'statements' | 'fixedIncomeStatements';

export const tableHeadCurrentAccount = {
  requestedDate: 'Data de solicitação ',
  settlementDate: 'Data de liquidação',
  description: 'Descrição',
  amountValue: 'Valor(R$)',
  availableBalance: 'Saldo(R$)',
  status: 'Status',
};

export const tableHeadFixedIncomeStatements = {
  movementDate: { desktop: 'Data de movimento', tablet: 'Data de mov.' },
  type: { desktop: 'Tipo', tablet: 'Tipo' },
  rate: { desktop: 'Taxa', tablet: 'Taxa' },
  amount: { desktop: 'Quantidade', tablet: 'Qtd.' },
  unitPrice: { desktop: 'Preço Unitário', tablet: 'Preço Unitário' },
  grossValue: { desktop: 'Valor bruto', tablet: 'Valor bruto' },
  iof: { desktop: 'IOF', tablet: 'IOF' },
  ir: { desktop: 'IR', tablet: 'IR' },
  netValue: { desktop: 'Valor líquido', tablet: 'Valor líquido' },
};

export const tableHeadPensionDetailsStatements = {
  date: { desktop: 'Data', tablet: 'Data' },
  launch: { desktop: 'Lançamento', tablet: 'Lançamento' },
  balance: { desktop: 'Saldo (R$)', tablet: 'Saldo (R$)' },
  quotaValue: { desktop: 'Valor da cota', tablet: 'Valor da cota' },
  quotasAmount: { desktop: 'Qtd. de cotas', tablet: 'Qtd. de cotas' },
  grossValue: { desktop: 'Valor bruto', tablet: 'Valor bruto' },
  ir: { desktop: 'IR', tablet: 'IR' },
  pensionNetValue: { desktop: 'Valor líquido', tablet: 'Valor líquido' },
};

export const tableHeadPensionIRRateStatements = {
  incidentRate: { desktop: 'Alíquota Incidente (%)', tablet: 'Alíquota Incidente (%)' },
  reserve: { desktop: 'Reserva (R$)', tablet: 'Reserva (R$)' },
  netReserve: { desktop: 'Reserva Líquida (R$)', tablet: 'Reserva Líquida (R$)' },
};

export const tableHeadPensionProfitabilityPeriodStatements = {
  incidentAliquot: { desktop: 'Alíquota Incidente (%)', tablet: 'Alíquota Incidente (%)' },
};

export const tableHeadFundMovementStatements = {
  movementDate: 'Data de movimento',
  quotationDate: 'Cotização',
  historic: 'Histórico',
  quotaValue: 'Cota',
  quotaQuantity: 'Quantidade',
  grossValue: 'Valor bruto',
  irValue: 'IR',
  iofValue: 'IOF',
  penaltyValue: 'Penalidade',
  netValue: 'Valor líquido',
};

export const tableHeadFundPositionStatements = {
  name: 'Fundo',
  applicationDate: 'Aplicação',
  profitability: 'Rent.',
  quota: 'Cota',
  quantity: 'Quant.',
  valueApplied: 'Valor aplicado',
  grossValue: 'Valor bruto',
  iof: 'IOF',
  ir: 'IR',
  netValue: 'Valor líquido',
};

type CurrentAccountStatementsRecords = keyof typeof tableHeadCurrentAccount;
type FixedIncomeStatementsRecords = keyof typeof tableHeadFixedIncomeStatements;
type FundMovementStatementsRecords = keyof typeof tableHeadFundMovementStatements;
type FundPositionStatementsRecords = keyof typeof tableHeadFundPositionStatements;
type PensionDetailsStatementsRecords = keyof typeof tableHeadPensionDetailsStatements;
type PensionIRRateStatementsRecords = keyof typeof tableHeadPensionIRRateStatements;
type PensionProfitabilityPeriodStatementsRecords =
  keyof typeof tableHeadPensionProfitabilityPeriodStatements;

export const currentAccountWidthCols: Record<
  CurrentAccountStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  requestedDate: { desktop: 14, tablet: 14 },
  settlementDate: { desktop: 14, tablet: 14 },
  description: { desktop: 30, tablet: 30 },
  amountValue: { desktop: 14, tablet: 14 },
  availableBalance: { desktop: 14, tablet: 14 },
  status: { desktop: 14, tablet: 14 },
};

export const fixedIncomeStatememntsWidthCols: Record<
  FixedIncomeStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  movementDate: { desktop: 15, tablet: 15 },
  type: { desktop: 10, tablet: 10 },
  rate: { desktop: 10, tablet: 10 },
  amount: { desktop: 10, tablet: 10 },
  unitPrice: { desktop: 11, tablet: 11 },
  grossValue: { desktop: 11, tablet: 11 },
  iof: { desktop: 11, tablet: 11 },
  ir: { desktop: 11, tablet: 11 },
  netValue: { desktop: 11, tablet: 11 },
};

export const fundPositionStatememntsWidthCols: Record<
  FundPositionStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  name: { desktop: 18, tablet: 18 },
  applicationDate: { desktop: 8, tablet: 8 },
  profitability: { desktop: 8, tablet: 8 },
  quota: { desktop: 8, tablet: 8 },
  quantity: { desktop: 8, tablet: 8 },
  valueApplied: { desktop: 10, tablet: 10 },
  grossValue: { desktop: 10, tablet: 10 },
  ir: { desktop: 10, tablet: 10 },
  iof: { desktop: 10, tablet: 10 },
  netValue: { desktop: 10, tablet: 10 },
};

export const funMovementStatememntsWidthCols: Record<
  FundMovementStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  movementDate: { desktop: 10, tablet: 10 },
  quotationDate: { desktop: 10, tablet: 10 },
  historic: { desktop: 10, tablet: 10 },
  quotaValue: { desktop: 10, tablet: 10 },
  quotaQuantity: { desktop: 10, tablet: 10 },
  grossValue: { desktop: 10, tablet: 10 },
  irValue: { desktop: 10, tablet: 10 },
  iofValue: { desktop: 10, tablet: 10 },
  penaltyValue: { desktop: 10, tablet: 10 },
  netValue: { desktop: 10, tablet: 10 },
};

export const pensionDetailsStatememntsWidthCols: Record<
  PensionDetailsStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  date: { desktop: 15, tablet: 15 },
  launch: { desktop: 20, tablet: 20 },
  balance: { desktop: 11, tablet: 11 },
  quotaValue: { desktop: 11, tablet: 11 },
  quotasAmount: { desktop: 11, tablet: 11 },
  grossValue: { desktop: 11, tablet: 11 },
  ir: { desktop: 10, tablet: 10 },
  pensionNetValue: { desktop: 10, tablet: 10 },
};

export const pensionIRRateStatememntsWidthCols: Record<
  PensionIRRateStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  incidentRate: { desktop: 45, tablet: 45 },
  reserve: { desktop: 40, tablet: 40 },
  netReserve: { desktop: 14.5, tablet: 14.5 },
};

export const pensionProfitabilityPeriodStatememntsWidthCols: Record<
  PensionProfitabilityPeriodStatementsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  incidentAliquot: { desktop: 100, tablet: 100 },
};

export const tableHeadAlignments: Partial<
  Record<
    | CurrentAccountStatementsRecords
    | FixedIncomeStatementsRecords
    | FundMovementStatementsRecords
    | FundPositionStatementsRecords
    | PensionIRRateStatementsRecords
    | PensionDetailsStatementsRecords
    | PensionProfitabilityPeriodStatementsRecords,
    'left' | 'center' | 'right'
  >
> = { netReserve: 'right', pensionNetValue: 'right' };

export const dataContent = {
  statements: { tableHead: tableHeadCurrentAccount, widthCols: currentAccountWidthCols },
  fixedIncomeStatements: {
    tableHead: tableHeadFixedIncomeStatements,
    widthCols: fixedIncomeStatememntsWidthCols,
  },
  fundPositionStatements: {
    tableHead: tableHeadFundPositionStatements,
    widthCols: fundPositionStatememntsWidthCols,
  },
  fundMovementStatements: {
    tableHead: tableHeadFundMovementStatements,
    widthCols: funMovementStatememntsWidthCols,
  },
  pensionDetailsStatements: {
    tableHead: tableHeadPensionDetailsStatements,
    widthCols: pensionDetailsStatememntsWidthCols,
  },
  pensionIRRateStatements: {
    tableHead: tableHeadPensionIRRateStatements,
    widthCols: pensionIRRateStatememntsWidthCols,
  },
  pensionProfitabilityPeriodStatements: {
    tableHead: tableHeadPensionProfitabilityPeriodStatements,
    widthCols: pensionProfitabilityPeriodStatememntsWidthCols,
  },
};

export const calculatePercentageWidth = (width: number) => {
  return Math.max(1, Math.min(width, 100));
};
